/**
 * 订单分享按钮
 */
import React, { useImperativeHandle, useRef, useState, memo } from 'react';
import { Modal, Button, message } from 'antd';
import { connect } from 'react-redux';
import copy from 'copy-to-clipboard';
import intl from 'react-intl-universal';

import Storage from '@/utils/storage';

import styles from './index.module.scss';

interface ModalRef {
  openModal: (text: string) => void;
}

const mapStateToProps = (store) => {
  return { shopList: store.user.shops || [] };
};
type MapStateProps = ReturnType<typeof mapStateToProps>;

const ShareModal: React.FC<{ innerRef: React.Ref<ModalRef> }> = (props) => {
  const [visible, setVisible] = useState(false);
  const [textContent, setTextContent] = useState('');

  // 关闭弹框
  const closeModal = () => {
    setVisible(false);
  };

  // 复制文本
  const copyText = (val: string) => {
    try {
      const isSuccess = copy(val);
      if (isSuccess) {
        message.success(intl.get('cmp_order_share_btn_message_copy_success'));
        return;
      }
    } catch (e) {
      //
    }
    message.error(intl.get('cmp_order_share_btn_message_copy_fail'));
  };

  // 一键复制
  const handleCopyClick = () => {
    copyText(textContent);
    // closeModal();
  };

  useImperativeHandle(
    props.innerRef,
    () => ({
      openModal: (shareText) => {
        try {
          setTextContent(shareText);
          setVisible(true);
          copyText(shareText);
        } catch (_) {
          //
        }
      },
    }),
    [],
  );

  return (
    <Modal
      title={intl.get('cmp_order_share_btn_modal_title')}
      centered
      maskClosable={false}
      open={visible}
      okText={intl.get('cmp_order_share_btn_modal_submiut')}
      width={720}
      wrapClassName={styles.shareModalContainer}
      onCancel={closeModal}
      onOk={handleCopyClick}
    >
      <div>
        <div>{intl.get('cmp_order_share_btn_modal_content_p1')}</div>
        <div className={styles.copyTextContent}>{textContent}</div>
        <div>{intl.get('cmp_order_share_btn_modal_content_p2')}</div>
      </div>
    </Modal>
  );
};

const Index: React.FC<MapStateProps> = (props) => {
  const shareModalRef = useRef<ModalRef>();

  // 打开分享弹框
  const showShareModal = () => {
    const { shopList } = props;
    const cacheCode = Storage.get('commonCode');
    const currentStore = shopList.find((item) => item.commonCode === cacheCode);
    if (currentStore) {
      shareModalRef.current.openModal(
        intl.get('cmp_order_share_btn_modal_share_content', {
          store: `${currentStore.commonCode}${currentStore.shopName}`,
          link: window.location.href,
        }),
      );
    }
  };

  return (
    <>
      <Button type="primary" ghost onClick={showShareModal}>
        {intl.get('cmp_order_share_btn_trigger')}
      </Button>
      <ShareModal innerRef={shareModalRef} />
    </>
  );
};

export default connect<MapStateProps>(mapStateToProps)(memo(Index));
